import { makeAutoObservable, runInAction } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { toastStore } from 'shared/ui'
import { OrganizationApi } from 'entities/Organization'

export class PurgePhiDataStore {
  private _modalId = nanoid()
  private _loading = false
  constructor() {
    makeAutoObservable(this)
  }

  onOpenModal = () => {
    modalStore.addModal({
      id: this._modalId,
      type: ModalTypeList.INFO,
      title: 'Purge PHI data',
      desc: 'This action will permanently archive PHI data (messages, attachments, notes) for all period. Logs will remain retained for 6 years as required by HIPAA. These data cannot be recovered',
      primaryAction: {
        text: 'Purge data',
        onAction: async () => {
          try {
            if (this._loading) return

            runInAction(() => {
              this._loading = true
            })

            await OrganizationApi.purgePhi()

            toastStore.add({
              type: 'success',
              title: 'PHI purge started',
              desc: 'We’ll email you as soon as the process is complete.',
            })
          } catch (e) {
            logger.error(e)

            toastStore.add({
              type: 'error',
              title: 'Something went wrong. Please try again',
            })
          } finally {
            modalStore.closeModal(this._modalId)

            runInAction(() => {
              this._loading = false
            })
          }
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => modalStore.closeModal(this._modalId),
      },
    })
  }

  get loading() {
    return this._loading
  }
}
